export const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export const PASSWORD_REGEX =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\][{}|;:'",.<>?\\/]).{8,}$/;

export const NAME_REGEX = /^[\p{L}\p{M}\x20\u3000'\-.·・]+$/u;

export const DOMAIN_LIKE_REGEX = /\p{L}{2,}\.\p{L}{2,}/u;

// Passport names must be entered in Roman letters (romaji): half-width Latin
// characters plus the separators commonly found in names.
export const ROMAJI_REGEX = /^[A-Za-z\x20'\-.]+$/;

// Passport numbers are half-width alphanumeric strings; lengths vary by
// country, so keep the bounds permissive.
export const PASSPORT_NUMBER_REGEX = /^[A-Za-z0-9]{5,20}$/;

// Japanese postal codes are 7 half-width digits, entered without the hyphen.
export const JAPAN_POST_CODE_REGEX = /^\d{7}$/;
